import React, { useContext, useEffect, useMemo, useState } from "react";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import soulIcon from "../../../../Assets/Images/SOUL.png";
import flowIcon from "../../../../Assets/Images/HeartToSoul.png";
import collaborativeIcon from "../../../../Assets/Images/CollabrativeIcon.png";
import growthIcon from "../../../../Assets/Images/Growth.png";
import fixed from "../../../../Assets/Images/fixed-new.png"
import conditional from "../../../../Assets/Images/Conditional2.png"

import HeartIcon from "../../../../Assets/Images/Heart-Icon.png";
import StrengthIcon from '../../../../Assets/Images/STRENGTH.png';
import SoulIcon from '../../../../Assets/Images/SOUL.png';
import MindIcon from '../../../../Assets/Images/MIND.png'


import flow_HM from '../../../../Assets/Images/flowScoreIcons/H-M.png'
import flow_HS from '../../../../Assets/Images/flowScoreIcons/H-S.png'
import flow_HST from '../../../../Assets/Images/flowScoreIcons/H-ST.png'
import flow_MH from '../../../../Assets/Images/flowScoreIcons/M-H.png'
import flow_MS from '../../../../Assets/Images/flowScoreIcons/M-S.png'
import flow_MST from '../../../../Assets/Images/flowScoreIcons/M-ST.png'
import flow_SH from '../../../../Assets/Images/flowScoreIcons/S-H.png'
import flow_SM from '../../../../Assets/Images/flowScoreIcons/S-M.png'
import flow_SST from '../../../../Assets/Images/flowScoreIcons/S-ST.png'
import flow_STH from '../../../../Assets/Images/flowScoreIcons/ST-H.png'
import flow_STM from '../../../../Assets/Images/flowScoreIcons/ST-M.png'
import flow_STS from '../../../../Assets/Images/flowScoreIcons/ST-S.png'


import Collabrative from "../../../../Assets/Images/COLLABORATIVE.png";
import Strategic from '../../../../Assets/Images/STRATEGIC.png';
import Performance from '../../../../Assets/Images/PERFORMANCE.png';
import Visionary from '../../../../Assets/Images/VISIONARY.png';

import GroupReportContext from "../../../../Context/GroupReportContext";
import { getMindsetSum } from "../../../../utils/helper";
import { applyFullTieOrder, isFullTie } from "../../../../utils/quadrantTieOrder";

const styles = {
  pageWrapper: { backgroundColor: "#FFFFFF" },
  mainTitle: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "14px", lineHeight: "18px", color: "#00577D", margin: 0, padding: "16px 0px" },
  introText: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, paddingBottom: "16px" },
  subText: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 400, fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, paddingBottom: "16px" },
  rememberTitle: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, paddingBottom: "10px" },
  rememberItem: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 400, fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, paddingBottom: "6px" },
  resultsTitle: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "14px", lineHeight: "18px", color: "#00577D", margin: 0, padding: "16px 0px" },
  cardsContainer: { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", padding: "0px", gap: "24px" },
  leftColumn: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", gap: "24px", width: "208px", height: "188px" },
  rightColumn: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", gap: "24px", width: "208px", height: "187.94px" },
  cardWrapper: { position: "relative", width: "208px", height: "82px" },
  card: { boxSizing: "border-box", position: "absolute", width: "208px", height: "73px", left: "0px", top: "9px", background: "#FFFFFF", border: "2px solid #00577D", borderRadius: "10px" },
  cardLabel: { position: "relative", width: "12ch", margin: "0px auto", left: "0px", top: "0px", background: "#FFFFFF", fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "11px", lineHeight: "15px", display: "flex", alignItems: "center", textAlign: "center", color: "#000000", justifyContent: "center" },
  cardContent: { display: "flex", flexDirection: "row", alignItems: "center", padding: "0px", gap: "16px", position: "absolute", height: "32px", left: "16px", top: "30px" },
  iconWrapper: { width: "32px", height: "32px" },
  icon: { width: "32px", height: "32px", objectFit: "contain" },
  cardText: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 400, fontSize: "11px", lineHeight: "15px", textTransform: "capitalise", color: "#000000", whiteSpace: "nowrap" },
};

export default function SnapShotResult({ apiData, reportType, pageNumber, previewData }) {

  const { getPercentileFromScore } = useContext(GroupReportContext);

  const [highestStarter, setHighestStarter] = useState('')
  const [mostSelecTedLeader, setMostSelecTedLeader] = useState("")
  const groupReportCtx = useContext(GroupReportContext);
  const { averagePercentages } = useContext(GroupReportContext);
  const { averagePercentagesMindset: contextAverage } = useContext(GroupReportContext);
  const [calculatedPercentage, setCalculatedPercentage] = useState(0);



  const normalize = (s) =>
    String(s ?? "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/_/g, "");

  const pickResults = (previewData, apiData, reportType) => {
    if (Array.isArray(previewData)) {
      const match = previewData.find(x => x?.reportType === reportType);
      if (match?.results) return match.results;
    }
    if (Array.isArray(apiData?.results)) return apiData.results;
    return [];
  };


  useEffect(() => {
    const selfStarters = groupReportCtx?.averagePercentagesSelf;
    // 4-way tie: first quadrant in clockwise order (Strength) wins
    const maxAvgObj = isFullTie(selfStarters?.map((el) => el?.avg))
      ? applyFullTieOrder(selfStarters, (el) => el?.name, (el) => el?.avg)[0]
      : selfStarters?.reduce((max, current) => {
        return current.avg > max.avg ? current : max;
      });

    setHighestStarter(maxAvgObj?.name?.toLowerCase());
  }, [apiData, groupReportCtx]);


  const getStarterHeading = () => {
    if (highestStarter?.includes("heart")) return "Heart";
    if (highestStarter?.includes("str")) return "Strength";
    if (highestStarter?.includes("soul")) return "Soul";
    if (highestStarter?.includes("mind")) return "Mind";
    else return "NONE";
  }

  const FLOW_IMAGES = {
    HS: flow_HS,
    HM: flow_HM,
    HST: flow_HST,
    MH: flow_MH,
    MS: flow_MS,
    MST: flow_MST,
    SH: flow_SH,
    SM: flow_SM,
    SST: flow_SST,
    STH: flow_STH,
    STM: flow_STM,
    STS: flow_STS,
  };


  const flowText = useMemo(() => {
    if (!averagePercentages || !averagePercentages?.length) return "";

    const sorted = applyFullTieOrder([...averagePercentages]
      .map(el => ({ name: el.name, value: Number(el.avg) || 0 }))
      .sort((a, b) => b.value - a.value));

    const first = sorted[0]?.name;
    const second = sorted[1]?.name;

    return (first && second) ? `${first} to ${second}` : "";
  }, [averagePercentages]);


  const flowImage = useMemo(() => {
    if (!averagePercentages || !averagePercentages?.length) return "";

    const sorted = applyFullTieOrder([...averagePercentages]
      .map(el => ({ name: el.name, value: Number(el.avg) || 0 }))
      .sort((a, b) => b.value - a.value));

    const highest = sorted[0]?.name?.toLowerCase();
    const secondHighest = sorted[1]?.name?.toLowerCase();

    const mapStarter = (starter) => {
      if (starter?.includes("str")) return "ST";
      return starter?.split("_")[0][0]?.toUpperCase();
    };

    const key = `${mapStarter(highest)}${mapStarter(secondHighest)}`;
    return FLOW_IMAGES[key?.toUpperCase()];

  }, [averagePercentages]);


  useEffect(() => {
    const performanceObj = groupReportCtx?.averagePercentagesLeadershipSelf?.find((el) => el?.name == "Performance");
    const strategiceObj = groupReportCtx?.averagePercentagesLeadershipSelf?.find((el) => el?.name == "Strategic");
    const visionaryObj = groupReportCtx?.averagePercentagesLeadershipSelf?.find((el) => el?.name == "Visionary");
    const collaborativeObj = groupReportCtx?.averagePercentagesLeadershipSelf?.find((el) => el?.name == "Collaborative");

    const avgPercentSelf = [performanceObj?.avg, collaborativeObj?.avg, visionaryObj?.avg, strategiceObj?.avg];
    const selfLeadership = groupReportCtx?.averagePercentagesLeadershipSelf;
    // 4-way tie: first style in clockwise order (Performance) wins
    const maxAvgObj = isFullTie(selfLeadership?.map((el) => el?.avg))
      ? applyFullTieOrder(selfLeadership, (el) => el?.name, (el) => el?.avg)[0]
      : selfLeadership?.reduce((max, current) => {
        return current.avg > max.avg ? current : max;
      });


    setMostSelecTedLeader(maxAvgObj?.name);
  }, [apiData]);




  useEffect(() => {
    // const dataToProcess = pickResults(previewData, apiData, reportType);

    // if (!Array.isArray(dataToProcess) || dataToProcess.length === 0) {
    //   // console.log('No valid data available, using context average');
    //   setCalculatedPercentage(Math.round(contextAverage));
    //   return;
    // }

    // console.log('Processing mindset data for', dataToProcess.length, 'members');

    // const MAX = 84;
    // const memberPercentages = [];

    // dataToProcess.forEach((member, index) => {
    //   const variables = Array.isArray(member?.variables) ? member.variables : [];
    //   if (variables.length === 0) {
    //     // console.log(`Skipping member ${index} - no variables array`);
    //     return;
    //   }

    //   let totalScore = 0;
    //   let hasAll12 = true;

    //   for (let i = 1; i <= 12; i++) {
    //     const target = `mindset${i}`;

    //     const varData = variables.find(v => normalize(v.variable) === target);

    //     const rawScore = varData?.score;
    //     const num = typeof rawScore === 'number'
    //       ? rawScore
    //       : Number(String(rawScore ?? '').trim());

    //     if (Number.isFinite(num)) {
    //       totalScore += num;
    //     } else {
    //       // console.log(`Missing or invalid mind_set_${i} for member ${index}`);
    //       hasAll12 = false;
    //       break;
    //     }
    //   }

    //   if (!hasAll12) {
    //     // console.log(`Skipping member ${index} - missing required mind_set scores`);
    //     return;
    //   }

    //   const pct = (totalScore / MAX) * 100;
    //   // console.log(`Member ${index}: Total=${totalScore}  %=${pct.toFixed(2)}`);
    //   memberPercentages.push(pct);
    // });

    // if (memberPercentages.length > 0) {
    //   const avg = memberPercentages.reduce((a, b) => a + b, 0) / memberPercentages.length;
    //   const roundedAvg = Math.round(avg * 100) / 100; // keep 2 decimals
    //   // console.log('--- Final Average ---', roundedAvg);
    //   setCalculatedPercentage(roundedAvg);
    // } else {
    //   // // console.log('No valid member percentages, using context average:', contextAverage);
    //   setCalculatedPercentage(Math.round(contextAverage));
    // }
    // let totalScore = 0;
    // if (apiData && Array.isArray(apiData.variables)) {
    //   const mindSetVariable = apiData.variables.find(
    //     (item) => item?.variable === "mind_set_sum"
    //   );
    //   if (mindSetVariable && typeof mindSetVariable.score === "number") {
    //     totalScore = mindSetVariable.score;
    //   }
    // }

    const mindsetSum = getMindsetSum(apiData?.variables);
    setCalculatedPercentage(mindsetSum)
  }, [previewData, apiData, reportType, contextAverage]);

  const percentage = getPercentileFromScore(calculatedPercentage || contextAverage);



  const getSelectedContentByPercentage = (percentage) => {
    if (percentage >= 0 && percentage < 16) {
      return "Fixed"
    } else if (percentage >= 16 && percentage < 36) {
      return "Fixed"
    } else if (percentage >= 36 && percentage < 66) {
      return "Conditional";
    } else if (percentage >= 66 && percentage < 86) {
      return "Growth";
    } else if (percentage >= 86 && percentage <= 100) {
      return "Growth";
    } else {
      return "Growth";
    }
  };

  const mindSet = getSelectedContentByPercentage(Math.round(percentage));





  const getStarterLogo = () => {
    if (highestStarter?.includes("heart")) return HeartIcon;
    if (highestStarter?.includes("str")) return StrengthIcon;
    if (highestStarter?.includes("soul")) return SoulIcon;
    if (highestStarter?.includes("mind")) return MindIcon;
    return undefined;
  }


  const getLeadershipImg = () => {
    const leadership = String(mostSelecTedLeader || '');
    if (leadership.includes('Collaborative')) return Collabrative
    if (leadership.includes('Strategic')) return Strategic
    if (leadership.includes('Performance')) return Performance
    if (leadership.includes('Visionary')) return Visionary
    return undefined;
  }


  const getMindImg = () => {
    if (mindSet.includes('Fixed')) return fixed
    if (mindSet.includes('Conditional')) return conditional
    if (mindSet.includes('Growth')) return growthIcon
    return undefined;
  }

  const resultsData = [
    [
      { label: "Starter", icon: getStarterLogo(), text: `SELF: ${getStarterHeading()} - Starter` },
      { label: "Leadership", icon: getLeadershipImg(), text: `SELF: ${mostSelecTedLeader}` }
    ],
    [
      { label: "Flow", icon: flowImage, text: `SELF: ${flowText}` },
      { label: "Mindset", icon: getMindImg(), text: `SELF: ${mindSet}` }
    ]
  ];



  return (
    <div style={styles.pageWrapper}>
      <HeaderPreview apiData={apiData} />

      <h2 style={styles.mainTitle}>SNAPSHOT RESULTS</h2>

      <p style={styles.introText}>
        This assessment offers a structured look at your life and leadership, grounded in validated testing. The results are designed to spark self-awareness and guide your growth. They provide valuable information, but they do not capture the full depth of who you are.
      </p>

      <p style={styles.subText}>
        Think of this Snapshot as a starting point for discovery. Self-assessment results reflect your own perspective, while 360° feedback brings in the views of others. Both are most helpful when explored with a trusted coach or consultant who can help you apply what you see.
      </p>

      <p style={styles.rememberTitle}>THREE THINGS TO REMEMBER:</p>

      <p style={styles.rememberItem}>
        <strong>1. This is a starting point.</strong> Your results open the door to discovery and are not a final verdict.
      </p>

      <p style={styles.rememberItem}>
        <strong>2. Growth improves with guidance.</strong> Working with a coach or guide helps you turn insight into action.
      </p>

      <p style={styles.rememberItem}>
        <strong>3. You are more than your data.</strong> These findings highlight patterns, but they do not define your worth or potential.
      </p>

      <h2 style={styles.resultsTitle}>YOUR SNAPSHOT RESULTS</h2>

      <div style={styles.cardsContainer}>
        {resultsData.map((column, colIndex) => (
          <div key={colIndex} style={colIndex === 0 ? styles.leftColumn : styles.rightColumn}>
            {column.map((card, cardIndex) => (
              <div key={cardIndex} style={styles.cardWrapper}>
                <div style={styles.card}></div>
                <div style={styles.cardLabel}>{card.label}</div>
                <div style={styles.cardContent}>
                  <div style={styles.iconWrapper}>
                    {card.icon && (
                      <img
                        src={card.icon}
                        alt={card.label}
                        style={{
                          ...styles.icon,
                          borderRadius: "50%",
                        }}
                      />
                    )}
                  </div>
                  <span style={styles.cardText}>{card.text}</span>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>

      <FooterPreview reportType={reportType} pageNumber={pageNumber} />
    </div>
  );
}
